var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { sdsCustomElement } from '../../../utilities/custom-components';
import { translate } from '../../../utilities/translate';
import { SdsGalleryItemBase } from '../_sds-gallery-item-base';
import styles from './sds-gallery-video.lit.scss';
const supportedVideoMimeTypes = ['video/mp4', 'video/webm', 'video/ogg'];
/**
 *  Gallery Video component that renders given content.
 *
 *  @slot The slot showing of the video content
 *
 *  @tag sds-gallery-video
 */
let SdsGalleryVideo = (() => {
    var _SdsGalleryVideo_contentType_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-gallery-video')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsGalleryItemBase;
    let _contentType_decorators;
    let _contentType_initializers = [];
    let _contentType_extraInitializers = [];
    var SdsGalleryVideo = _classThis = class extends _classSuper {
        static formatSeconds(seconds) {
            return new Date(seconds * 1000).toISOString().substring(seconds > 3600 ? 11 : 14, 19);
        }
        /**
         * Item content type
         * @attr
         */
        get contentType() { return __classPrivateFieldGet(this, _SdsGalleryVideo_contentType_accessor_storage, "f"); }
        set contentType(value) { __classPrivateFieldSet(this, _SdsGalleryVideo_contentType_accessor_storage, value, "f"); }
        constructor() {
            super();
            _SdsGalleryVideo_contentType_accessor_storage.set(this, __runInitializers(this, _contentType_initializers, ''));
            __runInitializers(this, _contentType_extraInitializers);
        }
        render() {
            return html ` ${this.getTemplate()} `;
        }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        getTemplate() {
            if (this.propertiesIsInvalid) {
                return html `
                <sds-empty data-card-content="">
                    <div slot="title">${translate('sds.gallery.item.properties.incomplete')}</div>
                </sds-empty>
            `;
            }
            if (this.isMainMode) {
                return html `
                <div
                    class="sds-gallery-item-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-full-screen-item-wrapper'
                    : ''}"
                >
                    <div
                        class="sds-gallery-actions-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-actions-wrapper-full'
                    : 'sds-gallery-actions-wrapper-default'}"
                    >
                        <span
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => this.toDownloadContent()}"
                        >
                            <sds-icon size="16" name="download"></sds-icon>
                        </span>
                        <span
                            id="sdsGalleryFullScreenToggle"
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => this.dispatchFullScreenEvent()}"
                        >
                            <sds-icon
                                size="16"
                                name="${this.isInFullScreen
                    ? 'exit_full_screen'
                    : 'go_full_screen'}"
                            ></sds-icon>
                        </span>
                    </div>

                    <video
                        controls
                        class="sds-gallery-item-content"
                        @loadeddata="${() => {
                    var _a, _b;
                    (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`loadingSpinner${this.identifier}`)) === null || _b === void 0 ? void 0 : _b.remove();
                }}"
                    >
                        <source src="${this.correspondingUrl}" type="${this.contentType}" />
                    </video>

                    <div id="loadingSpinner${this.identifier}" class="sds-gallery-spinner">
                        <sds-loader color="white" size="lg"></sds-loader>
                    </div>
                </div>
            `;
            }
            return html `
            <div class="sds-gallery-item-wrapper">
                <video
                    id="sdsGalleryThumbVideo${this.identifier}"
                    @loadeddata="${() => {
                var _a, _b;
                this.updateVideoData();
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`loadingSpinner${this.identifier}`)) === null || _b === void 0 ? void 0 : _b.remove();
            }}"
                >
                    <source src="${this.correspondingUrl}" type="${this.contentType}" />
                </video>

                <div
                    class="sds-gallery-thumb-video-item ${this.isInFullScreen
                ? 'sds-gallery-thumb-video-item-full'
                : 'sds-gallery-thumb-video-item-default'}"
                >
                    ${this.isInFullScreen ? html `<sds-icon size="24" name="video"></sds-icon>` : ''}
                    <span id="sdsGalleryVideoDuration${this.identifier}"></span>
                </div>

                <div id="loadingSpinner${this.identifier}" class="sds-gallery-spinner">
                    <sds-loader color="white" size="lg"></sds-loader>
                </div>
            </div>
        `;
        }
        updateVideoData() {
            var _a, _b;
            const videoEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`sdsGalleryThumbVideo${this.identifier}`);
            if (videoEl) {
                const videoDurationEl = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById(`sdsGalleryVideoDuration${this.identifier}`);
                if (videoEl.duration) {
                    videoDurationEl.innerText = SdsGalleryVideo.formatSeconds(videoEl.duration);
                }
            }
            this.adjustItemSize.call(videoEl);
        }
    };
    _SdsGalleryVideo_contentType_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsGalleryVideo");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _contentType_decorators = [property({
                type: String,
                attribute: 'content-type',
                reflect: true,
                hasChanged: (newVal) => {
                    if (!supportedVideoMimeTypes.includes(newVal)) {
                        console.warn(`Unexpected Content Mime Type ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        __esDecorate(_classThis, null, _contentType_decorators, { kind: "accessor", name: "contentType", static: false, private: false, access: { has: obj => "contentType" in obj, get: obj => obj.contentType, set: (obj, value) => { obj.contentType = value; } }, metadata: _metadata }, _contentType_initializers, _contentType_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsGalleryVideo = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsGalleryVideo = _classThis;
})();
export { SdsGalleryVideo };
